import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-e1b1a7e4"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "row-information" };
var _hoisted_2 = { class: "assignment-row-transport-marker transport-icon" };
var _hoisted_3 = { class: "assignment-row-wait-time" };
var _hoisted_4 = { class: "assignment-row-route-information" };
var _hoisted_5 = { key: 0 };
var _hoisted_6 = { key: 1 };
var _hoisted_7 = {
    key: 0,
    class: "assignment-row-number-passengers"
};
var _hoisted_8 = {
    key: 1,
    class: "assignment-row-team-marker team-icon"
};
var _hoisted_9 = { class: "assignment-row-origin-destination" };
var _hoisted_10 = {
    key: 0,
    class: "row-exclusion"
};
var _hoisted_11 = {
    key: 1,
    class: "row-actions"
};
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatAddress, formatStandardAddress, formatRouteInformationDistance, formatRouteInformationTime, formatNotAvailable } from '../../../../helpers/Formatters';
import { transportIdToLetters } from '../../../../helpers/Converters';
import { hasEnoughSeatbelts } from '../../../../helpers/Transport';
import AssignmentTableTransportMarker from '../AssignmentTableTransportMarker.vue';
import OriginDestination from '../OriginDestination.vue';
import AssistedAssignmentExclusionIcon from '../AssistedAssignmentExclusionIcon.vue';
import TextData from '../TextData.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseAssignmentTableRow',
    props: {
        transport: {
            type: Object,
            required: true,
        },
        showTeamColumn: {
            type: Boolean,
            default: true,
        },
        showPassengersColumn: {
            type: Boolean,
            default: false,
        },
        showActionButtons: {
            type: Boolean,
            default: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var locale = useI18n({ useScope: 'global' }).locale;
        var transportRequestLabel = computed(function () { return transportIdToLetters(props.transport.transportRequestId); });
        var origin = computed(function () { return formatAddress(props.transport.institutionName, props.transport.street, props.transport.city); });
        var destination = computed(function () { return formatStandardAddress(props.transport.destinationStreet, props.transport.destinationCity); });
        var hasRouteInformation = computed(function () { return !!props.transport.routeInformation; });
        var getColorCodeForSeatbelts = computed(function () {
            if (!hasEnoughSeatbelts(props.transport)) {
                return 'red';
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["assignment-row", { active: __props.transport.isActive }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(AssignmentTableTransportMarker, {
                            num: transportRequestLabel.value,
                            status: __props.transport.status,
                            "transport-id": __props.transport.transportRequestId
                        }, null, 8 /* PROPS */, ["num", "status", "transport-id"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "awaiting-time")
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (hasRouteInformation.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(TextData, { variant: "xxs" }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(_unref(formatRouteInformationDistance)(props.transport.routeInformation, _unref(locale))), 1 /* TEXT */)
                                    ]; }),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(TextData, { variant: "xxs" }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(_unref(formatRouteInformationTime)(props.transport.routeInformation)), 1 /* TEXT */)
                                    ]; }),
                                    _: 1 /* STABLE */
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(TextData, { variant: "xxs" }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(_unref(formatNotAvailable)(_unref(locale))), 1 /* TEXT */)
                                    ]; }),
                                    _: 1 /* STABLE */
                                })
                            ]))
                    ]),
                    (__props.showPassengersColumn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(TextData, {
                                variant: "xxs",
                                fontColor: getColorCodeForSeatbelts.value
                            }, {
                                default: _withCtx(function () { return [
                                    _createTextVNode(_toDisplayString(__props.transport.nbOfPassengers), 1 /* TEXT */)
                                ]; }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["fontColor"]),
                            _createVNode(TextData, {
                                variant: "xxs",
                                fontColor: getColorCodeForSeatbelts.value
                            }, {
                                default: _withCtx(function () { return [
                                    _createTextVNode(_toDisplayString(__props.transport.nbOfSeatBelts), 1 /* TEXT */)
                                ]; }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["fontColor"])
                        ]))
                        : _createCommentVNode("v-if", true),
                    (__props.showTeamColumn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _renderSlot(_ctx.$slots, "team-icon")
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(OriginDestination, {
                            origin: origin.value,
                            destination: destination.value
                        }, null, 8 /* PROPS */, ["origin", "destination"])
                    ])
                ]),
                (__props.transport.isExcludedFromAssistedAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(AssistedAssignmentExclusionIcon)
                    ]))
                    : (__props.showActionButtons)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _renderSlot(_ctx.$slots, "first-additional-cell"),
                            _renderSlot(_ctx.$slots, "second-additional-cell")
                        ]))
                        : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
